import React, { useState, useEffect } from 'react';

const TelegramDebug: React.FC = () => {
  const [debugInfo, setDebugInfo] = useState<any>({});

  useEffect(() => {
    const tg = window.Telegram?.WebApp;

    const info = {
      // Проверка наличия Telegram
      hasTelegram: !!window.Telegram,
      hasWebApp: !!window.Telegram?.WebApp,

      // Данные пользователя
      hasUser: !!tg?.initDataUnsafe?.user,
      userId: tg?.initDataUnsafe?.user?.id || 'НЕТ',
      firstName: tg?.initDataUnsafe?.user?.first_name || 'НЕТ',
      username: tg?.initDataUnsafe?.user?.username || 'НЕТ',

      // initData
      hasInitData: !!tg?.initData,
      initDataLength: tg?.initData?.length || 0,

      // URL параметры
      urlHasTgWebAppData: window.location.search.includes('tgWebAppData'),
      fullUrl: window.location.href,

      // Platform
      platform: tg?.platform || 'НЕТ',
      version: tg?.version || 'НЕТ',
    };

    setDebugInfo(info);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#f0f0f0',
      padding: '20px',
      overflow: 'auto',
      zIndex: 9999,
      fontFamily: 'monospace',
      fontSize: '12px'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ color: '#0284c7', marginBottom: '20px' }}>🔍 Telegram WebApp Debug</h1>

        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#333', fontSize: '16px', marginBottom: '10px' }}>📱 Telegram Detection:</h2>
          <div style={{ backgroundColor: '#f9fafb', padding: '10px', borderRadius: '4px' }}>
            {Object.entries(debugInfo).map(([key, value]) => (
              <div key={key} style={{ marginBottom: '8px' }}>
                <strong>{key}:</strong>{' '}
                <span style={{
                  color: value === 'НЕТ' || value === false ? 'red' : 'green',
                  fontWeight: 'bold'
                }}>
                  {typeof value === 'boolean' ? (value ? '✅ ДА' : '❌ НЕТ') : String(value)}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#333', fontSize: '16px', marginBottom: '10px' }}>🔑 localStorage:</h2>
          <div style={{ backgroundColor: '#f9fafb', padding: '10px', borderRadius: '4px' }}>
            <div><strong>token:</strong> {localStorage.getItem('token') ? '✅ ЕСТЬ' : '❌ НЕТ'}</div>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#333', fontSize: '16px', marginBottom: '10px' }}>📋 Full initDataUnsafe:</h2>
          <pre style={{
            backgroundColor: '#1e293b',
            color: '#22c55e',
            padding: '10px',
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '11px'
          }}>
            {JSON.stringify(window.Telegram?.WebApp?.initDataUnsafe, null, 2)}
          </pre>
        </div>

        <button
          onClick={() => window.location.href = '/'}
          style={{
            backgroundColor: '#0284c7',
            color: 'white',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          ← Назад на главную
        </button>
      </div>
    </div>
  );
};

export default TelegramDebug;
